import { statusList } from 'src/app//shared/models/users/users/statusList';

export class ListData {
  usersCount!: number;
  pagedData!: {
    labUserId: number;
    fullName: string;
    userName: string;
    email: string;
    labName: string;
    memberSince: Date;
    userStatus: statusList;
    userLogo: string;
    labLogo: string;
    roles: string[];
  }[];
}
